import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
	state: {
		user  : {
			logged		: false,
			name      	: '',
			token     	: '',
			// token_emp 	: ''
		}
	},
	mutations: {
		login(state, userInfo){
			state.user.logged		= true
			state.user.token      	= userInfo.token
			state.user.name       	= userInfo.name
			// state.user.token_emp  	= userInfo.token_emp
		},
		logout(state){
			fetch(server + 'auth/logout/' + state.user.token, {
				method: 'POST'
			})
				.then(response => (response.json()))
				.then(responseJSON => {
					state.user = {
						logged		: false,
						name      	: '',
						token     	: ''
						// token_emp 	: ''
					}
				})
				.catch(error => {
					state.user = {
						logged		: false,
						name      	: '',
						token     	: ''
						// token_emp 	: ''
					}
				})
		}
	},
	actions: {
		LOGIN: function(context, {info, vm}){
			return new Promise((resolve, reject) => {
                fetch( server + 'auth/login', {
                    method: 'POST',
					headers: new Headers({
						"Content-Type": "application/json",
						"Authentication" : JSON.stringify({
							'login' : info.user,
							'senha' : info.pass
						})
					})
                })
                    .then(response => (response.json()))
					.then(responseJSON => {
						if(responseJSON.data === true){
							vm.$setItem('gestor-board', {
								token		: responseJSON.response[0].token,
								name		: responseJSON.response[0].name,
								// token_emp	: responseJSON.result.token_emp,
								logged		: true
							})
								.then(response => {
									context.commit('login', responseJSON.response[0])
									resolve({
										status: true,
										data: {}
									})
								})
						}else{
							reject({
								status: false,
								data: responseJSON.response[0].message
							})
						}
					})
					.catch(error => {
						reject({
							status: false,
							data: error
						})
					})
			})
		}
	},
	modules: {
	},
	getters: {
		getLogged: state => {
			return state.user.logged
		},

		getUserName: state => {
			if(state.user.logged){
				return state.user.name
			}
		},

		getToken: state => {
			if(state.user.logged){
				return state.user.token
			}
		}
	}
})

export default store	